import React, { useEffect, useState } from 'react';
// import ImageUploader from 'react-images-upload';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useApi } from '../Store/ApiContext';
import { customAlphabet } from 'nanoid';
import { Upload } from 'lucide-react';
import { t } from 'i18next';

const UploadImages = ({
  unitCode,
  pathImage = "IDs",
  bookingData,
  setBookingData,
  keyImages,
  title = "ارفع الصور هنا",
  accept = "image/*"
}) => {

  const { getSlug } = useApi();
  const [uploadedMediaUrls, setUploadedMediaUrls] = useState([]);
  const [loadingUploadImage, setLoadingUploadImage] = useState(false);

  const handleImageUpload = async (images) => {
    setLoadingUploadImage(true);
    const files = (images.target.files);
    const slug = getSlug();
    const storage = getStorage();
    const storageRef = ref(storage, `${pathImage}/${slug}`);
    const uploadedMediaUrl = [];

    for (let i = 0; i < files.length; i++) {
      if (files[i].size <= 5242880) {
        const image = files[i];
        const nanoid = customAlphabet('1234567890abcdefghtklmnoqzx', 16);
        const imageName = nanoid();
        const imageRef = ref(storageRef, imageName);
        await uploadBytes(imageRef, image);

        const downloadURL = await getDownloadURL(imageRef);
        // Store the downloadURL in your bookingDatabase
        console.log('Download URL:', downloadURL.split('?')[0] + "?alt=media");
        uploadedMediaUrl.push(downloadURL.split('?')[0] + "?alt=media")
      }
    }

    // Fix: Properly merge with existing images from the specific keyImages
    const currentImages = bookingData[keyImages] || [];
    setUploadedMediaUrls([...currentImages, ...uploadedMediaUrl]);
    setLoadingUploadImage(false);
  };

  async function handleImageRemoveStorage(image) {
    const imageName = image.split('%2F').reverse()[0].split("?")[0];
    const storage = getStorage();
    const slug = getSlug();
    const desertRef = ref(storage, `${pathImage}/${slug}/${imageName}`);

    try {
      await deleteObject(desertRef);
    } catch (error) {
      console.log(error);
    }

    const myUrls = [...bookingData[keyImages]];
    for (let i = 0; i < myUrls.length; i++) {
      if (myUrls[i].split('%2F').reverse()[0].split("?")[0] === imageName) {
        myUrls.splice(i, 1);
      }
    }
    setUploadedMediaUrls(myUrls);
  }

  useEffect(() => {
    if (bookingData.orgPaymentMethod === "cash" && bookingData.paymentImage?.length) {
      for (const key in bookingData.paymentImage) {
        const element = bookingData.paymentImage[key];
        console.log(element);
        handleImageRemoveStorage(element);
      }
      setBookingData((prev) => ({ ...prev, paymentImage: [] }));
    }
  }, [bookingData.orgPaymentMethod])


  useEffect(() => {
    // Only update if uploadedMediaUrls is different from current bookingData[keyImages]
    if (bookingData[keyImages] && JSON.stringify(uploadedMediaUrls) !== JSON.stringify(bookingData[keyImages])) {
      let myData = { ...bookingData }
      if (uploadedMediaUrls?.length) {
        myData[keyImages] = uploadedMediaUrls;
        setBookingData(myData)
        console.log(`Updated ${keyImages}:`, uploadedMediaUrls);
      } else if (myData[keyImages]?.length) {
        // If there are uploaded images but none are selected, keep the existing ones
        setUploadedMediaUrls(myData[keyImages]);
      } else {
        // If no uploaded images, clear the keyImages array in bookingData
        myData[keyImages] = [];
        setBookingData(myData)
        console.log(`Cleared ${keyImages}`);
      }
    }
  }, [uploadedMediaUrls])

  return (
    <div>
      <div className="mb-4">
        {/* <div className='ps-3 pb-3'>
          <h5 className="text-gray-800 font-semibold">
            {t("pleaseUploadPhotosOfYourBookingID")}
          </h5>
        </div> */}

        <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center hover:border-blue-700 transition-colors">
          <input
            disabled={loadingUploadImage}
            multiple
            type="file"
            id={`file-upload-${keyImages}`}
            className="hidden"
            accept={accept}
            onChange={handleImageUpload}
          />
          <label
            htmlFor={`file-upload-${keyImages}`}
            className="cursor-pointer flex flex-col items-center"
          >
            <div className="w-12 h-12 bg-blue-100 rounded-2xl flex items-center justify-center mb-3">
              {loadingUploadImage === false ? (
                <Upload className="w-6 h-6 text-blue-600" />
              ) : (
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
              )}
            </div>
            <span className="text-gray-600 font-medium">
              {title}
            </span>
          </label>
          {uploadedMediaUrls.length > 0 && (
            <div className="mt-4">
              <div className='flex flex-wrap gap-3 justify-start'>
                {bookingData[keyImages]?.map((url, index) => (
                  <div className='relative group' key={index}>
                    <div className="w-16 h-16 rounded-xl overflow-hidden border-2 border-gray-200 hover:border-blue-300 transition-colors">
                      <img className='w-full h-full object-cover' src={url} alt="uploaded" />
                    </div>
                    <button
                      className='absolute -top-2 -right-2 w-6 h-6 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center text-xs transition-colors shadow-md'
                      onClick={() => handleImageRemoveStorage(url)}
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <p className='text-center text-gray-500 text-sm mt-2'>{t("maximumFileSize")}</p>
      </div>

      {/* {uploadedMediaUrls.length > 0 && (
        <div className="mt-4">
          <div className='flex flex-wrap gap-3 justify-start'>
            {bookingData[keyImages]?.map((url, index) => (
              <div className='relative group' key={index}>
                <div className="w-16 h-16 rounded-xl overflow-hidden border-2 border-gray-200 hover:border-blue-300 transition-colors">
                  <img className='w-full h-full object-cover' src={url} alt="uploaded" />
                </div>
                <button
                  className='absolute -top-2 -right-2 w-6 h-6 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center text-xs transition-colors shadow-md'
                  onClick={() => handleImageRemoveStorage(url)}
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </div>
            ))}
          </div>
        </div>
      )} */}
    </div>
  );
};

export default UploadImages;